<router-outlet ></router-outlet>

<!-- <div *ngIf="loading" class="w-100 h-100 d-flex align-items-center justify-content-center">
    <app-loading></app-loading>
</div> -->